import NotificationItems from "./notification-items";

export default NotificationItems;